/**
 * Mixin compartido para lógica de datos de ventas (store, validación y formato).
 * Usado por Sales.vue y SalesWidget.vue para evitar duplicación.
 */
import { formatDisplayDateFromStore } from '@/utils/dateFormatters'

export default {
    computed: {
        sales() {
            const storeData = this.$store.getters['sales/getData']
            if (!storeData || storeData === false) {
                return null
            }
            const salesData = storeData.data || storeData
            if (!salesData || typeof salesData !== 'object') {
                return null
            }
            if (salesData.forecast === null || salesData.forecast === undefined ||
                salesData.actual === null || salesData.actual === undefined) {
                return null
            }
            return salesData
        },
        summary() {
            if (!this.sales || !this.sales.summary) {
                return null
            }
            return this.sales.summary
        },
        hasValidSalesData() {
            return this.sales !== null &&
                this.sales !== undefined &&
                this.sales.forecast !== null &&
                this.sales.forecast !== undefined &&
                typeof this.sales.forecast === 'object' &&
                this.sales.actual !== null &&
                this.sales.actual !== undefined &&
                typeof this.sales.actual === 'object'
        }
    },
    methods: {
        formatDate(date) {
            return formatDisplayDateFromStore(date, { style: 'long' })
        }
    }
}
